import React from 'react';
import { Link } from 'react-router-dom';
import { useLanguage } from '@/services/languageService';

/**
 * 广告栏属性接口
 */
interface WhichPokemonBannerProps {
  /**
   * 自定义CSS类
   */
  className?: string;
  /**
   * 自定义样式
   */
  style?: React.CSSProperties;
  /**
   * 自定义背景颜色渐变
   * 默认为 from-red-500 via-purple-700 to-blue-500
   */
  bgGradient?: string;
}

/**
 * "我是哪个宝可梦"广告栏组件
 * 
 * 显示带有动画效果的广告栏，引导用户前往"我是哪个宝可梦"功能页面
 * 
 * @returns {JSX.Element} WhichPokemonBanner组件
 */
const WhichPokemonBanner: React.FC<WhichPokemonBannerProps> = ({
  className = '',
  style,
  bgGradient = 'from-red-500 via-purple-700 to-blue-500'
}) => {
  const { t, currentLanguage } = useLanguage();

  /**
   * 根据当前语言获取导航链接
   * @param {string} path - 目标路径
   * @returns {string} - 适配当前语言的路径
   */
  const getLanguagePath = (path: string): string => {
    if (currentLanguage === 'en') {
      return path;
    } else {
      return `/${currentLanguage}${path}`;
    }
  };

  return (
    <div className={`my-12 ${className}`} style={style}>
      <Link 
        to={getLanguagePath("/which-pokemon-am-i")} 
        className={`block w-full bg-gradient-to-r ${bgGradient} rounded-xl shadow-lg hover:shadow-2xl transition-all duration-300 transform hover:-translate-y-1 overflow-hidden`}
      >
        <div className="px-6 py-8 text-center animate-floating">
          <div className="flex justify-center items-center gap-2 mb-3">
            <img 
              src="/st-pokemon-ball.svg" 
              alt="Pokemon Logo" 
              className="w-8 h-8 animate-spin-slow"
              style={{ animationDuration: '6s' }} 
            />
            <h3 className="text-2xl font-bold text-white">{t("enterHeightWeight")}</h3>
          </div>
          <p className="text-white text-opacity-90 text-lg">
            {t("whichPokemonMatchesSize")}
          </p>
          <button className="mt-4 bg-white text-blue-700 font-semibold py-2 px-6 rounded-full hover:bg-opacity-90 transition-colors">
            {t("findMyPokemon")}
          </button>
        </div>
      </Link>
    </div>
  );
};

export default WhichPokemonBanner; 